import React from "react"

const FacebookIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        d="M25.3121 25.8908V34.1651H21.5112V25.8908H18.3535V22.5358H21.5112V21.3151C21.5112 16.7833 23.4043 14.4004 27.4099 14.4004C28.6379 14.4004 28.9449 14.5977 29.6174 14.7586V18.077C28.8645 17.9455 28.6525 17.8724 27.8704 17.8724C26.9421 17.8724 26.4451 18.1355 25.9919 18.6545C25.5387 19.1734 25.3121 20.0725 25.3121 21.359V22.5431H29.6174L28.4625 25.8981H25.3121V25.8908Z"
        fill="#111A2F"
      />
    </svg>
  )
}

export default FacebookIcon
